import {createContext, useContext} from 'react';
import {ExperimentBag} from './ExperimentBag';

export const ExperimentsContext = createContext<ExperimentBag>({});

export const useExperiments = () => {
  return useContext(ExperimentsContext);
};
